<script setup lang="ts">
    useSeoMeta({
        title: "お客さま本位の業務運営に関する方針｜株式会社Bang",
        description: "株式会社Bangのお客さま本位の業務運営に関する方針を掲載しています。",
        ogTitle: "お客さま本位の業務運営に関する方針｜株式会社Bang",
        ogDescription: "株式会社Bangのお客さま本位の業務運営に関する方針を掲載しています。",
        ogUrl: "https://www.bang-inc.jp/info/customer",
    });

    const breadcrumbsItems = [
        { text: "トップページ", href: "/" },
        { text: "お客さま本位の業務運営に関する方針", href: "/info/customer" },
    ];
</script>

<template>
  <main class="customer">
    <!-- パンくずリスト -->
    <Breadcrumbs :items="breadcrumbsItems" />
    <div class="customer__body">
        <HeadingCorp :level="1">お客さま本位の業務運営に関する方針</HeadingCorp>
        <section class="customer__section">
            <p class="customer__section-text">
                株式会社Bang（代表取締役　長山　真己）および属する従業員一同は、お客さま本位の業務運営を推進し、お客さまにふさわしいサービスを提供すべく、令和7年9月1日付にて「お客さま本位の業務運営に関する方針」を作成いたしました。<br>
                その上で、当社はお客さま本位の良質な金融商品・サービスの提供を追求してまいりましたが、当社としてより良いサービスの提供を行うため、この宣言に表された理念を常により良いものへと継続・発展させ、お客さま本位の業務運営の基本としてさらに徹底を図ってまいります。
            </p>
            <p class="customer__right-text">
                令和７年 8月 18日 策定<br><br>
                株式会社Bang<br>
                従業員一同<br>
                代表取締役 長山 真己
            </p>
            <p class="customer__section-text">
                本取組方針の【 】は、金融庁が公表している「顧客本位の業務運営に関する原則」（以下、「原則」という）のどの原則に対応しているかを示しております。「顧客本位の業務運営に関する原則」の詳細につきましては、金融庁ホームページをご確認下さい。<br>
                <a href="https://www.fsa.go.jp/policy/kokyakuhoni/kokyakuhoni.html" target="_blank">https://www.fsa.go.jp/policy/kokyakuhoni/kokyakuhoni.html</a>
            </p>
        </section>

        <!-- 方針１ -->
        <section class="customer__section">
            <div class="customer__section-box">
                <HeadingCorp :level="2">方針１．当社理念 【原則２】</HeadingCorp>
                <p class="customer__section-text">
                    当社は「見えないものを見えるように わかりにくいものをわかりやすく」を経営理念として、いわゆるダイレクト型の自動車保険を中心にITを駆使してお客さまに最も適した保険商品を、お客さま自身で簡単に選んでもらえるよう、サービスの開発・提供に努めて参りました。<br>
                    今後も当社理念を実現するために、お客さま本位の業務運営をより推進し、これまで以上にお客さまにより良いサービスを提供することができるよう、努めて参ります。
                </p>
            </div>
            <div class="customer__section-box">
                <HeadingCorp :level="3">①WEBサイトの運営</HeadingCorp>
                <p class="customer__section-text">
                    当社が運営または運営を委託しているWEB サイトにおいて、お客さま自身がわかりにくい、知りたいことについて、適切にかつ過不足なく正確な情報をわかりやすく提供できるよう、WEB サイトの掲載においては事前に当該保険会社にて審査・承認を得ております。<br>
                    また、商品改定等が発生した場合には遅延なく最新の情報を掲載するよう、募集文書の管理を徹底することで、お客さま自身がご都合の良いタイミングでいつでも安心して利用できる WEB サイトの運営に努めて参ります。
                </p>
            </div>
            <div class="customer__section-box">
                <HeadingCorp :level="3">②お電話での案内</HeadingCorp>
                <p class="customer__section-text">
                    当社は WEB サイトの運営と並行してお電話（テレマーケティング）によるお問い合わせにも対応しております。<br>
                    各種手続きや契約内容の照会など、WEB サイトではわからない、もしくはインターネットに不得手な方に対しても、いつでも安心して利用していただける体制の構築に努めて参ります。
                </p>
            </div>
        </section>

        <!-- 方針２ -->
        <section class="customer__section">
            <div class="customer__section-box">
                <HeadingCorp :level="2">方針２．コンプライアンス体制の整備 【原則２】</HeadingCorp>
                <p class="customer__section-text">
                    当社は、お客さまに安心していただけるサービスを提供できる体制を構築するために、お客さま第一主義のもと、厳格なコンプライアンス体制を構築し、ガバナンス体制の整備・改善・強化に努めております。
                </p>
            </div>
            <div class="customer__section-box">
                <HeadingCorp :level="3">①業務部門から独立した代表取締役直下の内部監査部門による上記に係る業務監査及び改善</HeadingCorp>
                <p class="customer__section-text">
                    当社では、営業・管理部門から独立した代表取締役直下の内部監査部門を設置しており、年に一度、全営業部門・管理部門を対象とし、内部監査を行い、その実施結果を社長及び関係部門へ報告し、経営が実態を認識し、改善指示を行う体制を整備しております。
                </p>
            </div>
            <div class="customer__section-box">
                <HeadingCorp :level="3">②情報管理・情報セキュリティ体制の整備</HeadingCorp>
                <p class="customer__section-text">
                    当社は、お客さまからお預かりした大切な個人情報を適正に管理するため、情報セキュリティのために十分な技術的措置を行い、標的型メールやサイバー攻撃に対するサイバーセキュリティ体制を整備しているとともに、情報セキュリティ体制の維持・向上に努めております。
                </p>
            </div>
            <div class="customer__section-box">
                <HeadingCorp :level="3">③お客さまの声の管理体制の整備</HeadingCorp>
                <p class="customer__section-text">
                    当社では苦情・ご意見・ご要望・ご相談等、「コールセンター・カスタマーセンター等へのお申し出」「お申込み確認電話におけるご回答」、「SMS アンケートでのご回答」「WEB サイト上のお問い合わせフォーム」など幅広くお客さまの声を集約し、経営に活かすため以下の取り組みを行っております。
                </p>
                <div class="customer__section-block">
                    <HeadingCorp :level="4">■苦情の分析と改善</HeadingCorp>
                    当社はお客さまからの苦情に関して、「誤解を含む不満足の表明」と広義に定義し、幅広に収集しております。<br>
                    お客さまよりいただいた苦情について、調査・分析を行い、お客さまの苦情及びその起因となった案内が、各種法令及び国の定めるその他の規範、各保険会社のルール等と照らし、どのレベルにあたる行為かを確認するとともに、社長及び関係部門 に報告の上、内容に応じた改善施策を実施いたします。<br>
                </div>
                <div class="customer__section-block">
                    <HeadingCorp :level="4">■お客さまのご要望・ご意見等の経営への反映</HeadingCorp>
                    苦情以外にもお客さまのご要望・ご意見等のお客さまの声を収集し、当社におけるサービスの改善・向上を図ってまいります。
                </div>
            </div>
        </section>

         <!-- 方針３ -->
       <section class="customer__section">
            <HeadingCorp :level="2">方針３．利益相反等の管理について 【原則３】</HeadingCorp>
            <div class="customer__section-box">
                <HeadingCorp :level="3">①保険会社の商品の取り扱いにあたって</HeadingCorp>
                <p class="customer__section-text">
                    当社は保険代理店であり、ご案内する保険商品の組成に関わることはありませんが、各保険会社から保険商品の締結の媒介あるいは代理によりご案内する商品の販売委託元である保険会社から代理店手数料を受領します。<br>
                    そのため、お客さまの利益等が不当に害される、利益相反となることの無いように、保険会社毎の代理店手数料額が異なる点には一切影響されることなく、お客さまの意向に沿った商品について推奨理由を明確に説明した上で提案・推奨します。<br>
                    また、当社は保険会社が行うキャンペーン等による報酬は一切受け取っておりません。
                </p>
            </div>
        </section>

        <!-- 方針４ -->
        <section class="customer__section">
            <HeadingCorp :level="2">方針４．お客さまへの十分かつ分かりやすい説明と情報の提供 【原則４，５】</HeadingCorp>
            <div class="customer__section-box">
                <HeadingCorp :level="3">①保険商品に関する重要な事項の説明</HeadingCorp>
                <p class="customer__section-text">
                    ご契約いただく保険商品について十分にご理解いただいた上でご契約いただくために、お客さまのご理解の状況を十分に確認の上、ご契約における保険の契約概要や重要事項や不利益事項の分かりやすい説明、乗換・解約新規契約時の不利益事項のご説明を行います。<br>
                    また、ご高齢のお客さま等特に分かりやすく説明を行う必要があるお客さまについては、よりきめ細かい説明を行うともに、ご案内を行ったことをお申込みの際に確認する体制を整備し、お客さまの満足度の向上を図っております。<br>
                    具体的には、テレマーケティングにおいては説明が必要な事項についてのトークスクリプトやチェックシートを整備しております。<br>
                    また、ウェブサイトに募集文書を掲載する場合は、必ず事前に当該保険会社の審査・承認を受けた上で掲載するとともに、募集文書の管理を徹底し、お客さまへの適切な説明に努めております。
                </p>
            </div>
            <div class="customer__section-box">
                <HeadingCorp :level="3">②特に留意が必要な事項の説明について</HeadingCorp>
                <p class="customer__section-text">
                    当社が保険会社から販売を委託されている保険商品を始めとする当社が取扱う金融商品について、パッケージでの販売を行う商品はございません。
                </p>
            </div>
        </section>

        <!-- 方針５ -->
        <section class="customer__section">
            <HeadingCorp :level="2">方針５．お客さまにふさわしいサービスの提供 【原則６】</HeadingCorp>
            <div class="customer__section-box">
                <HeadingCorp :level="3">①お客さまのご意向の適正な把握と意向に沿った商品の選択と推奨</HeadingCorp>
                <p class="customer__section-text">
                    当社では、お客さまのご年齢やご家族構成や資産の状況、金融商品の取引における知識・経験、保険商品のご検討の目的等を鑑み、お客さまの今後のライフプランを十分に確認の上、お客さまのご意向を把握し、お客さまの意向に沿った商品について推奨理由を明確に説明した上で提案・推奨します。
                </p>
            </div>
            <div class="customer__section-box">
                <HeadingCorp :level="3">②当社における商品の選択と推奨について</HeadingCorp>
                <p class="customer__section-text">
                    当社では主に WEB サイトに保険商品を掲載し、お客さまにご覧いただき、お選びいただく通販型の保険代理店で、以下の通りご提案する商品の選択および推奨を行っております。<br>
                    また、WEB サイトでは取扱いができない一部商品や、お客さまから直接問い合わせがあった場合につき、テレマーケティング（電話）で保険のご案内を行っており、以下の通り各項目を勘案した上で商品の選択および推奨を行っております。
                </p>
            </div>
            <div class="customer__section-box">
                <HeadingCorp :level="4">《商品選定方針》</HeadingCorp>
                <strong>WEB サイトによる販売について</strong>
                <ul>
                    <li class="customer__definition-item">(1) 当社では、取扱可能な保険会社のうち、保険会社から掲載の許可が得られた商品・プランの概要を掲載しています。</li>
                    <li class="customer__definition-item">(2) (1)の WEB サイトに掲載されていない商品であっても、当社で取り扱い実績のある既契約商品の継続または乗り換えの商品を当社が選定し、または、追加契約となる商品を当社が選定しご案内いたします。</li>
                    <li class="customer__definition-item">
                        (3)当社は、以下の損害保険会社の代理店であり、当サイト上で保険契約の締結の媒介を行うもので、保険契約締結の代理権および告知受領権は有しておりません。したがいまして、保険契約は、お客さまからの保険契約のお申し込みに対して取扱保険会社が承諾したときに有効に成立します。
                        <div class="customer__indent">
                            ・保険会社
                            <ul>
                                <li>日新火災海上保険株式会社</li>
                                <li>チューリッヒ保険会社</li>
                                <li>ジェイアイ傷害火災保険株式会社</li>
                                <li>ソニー損害保険株式会社</li>
                            </ul>
                        </div>
                    </li>
                </ul>
                <strong>テレマーケティングによる販売について</strong>
                <ul>
                    <li class="customer__definition-item">(1) お客さまのご意向に沿った商品の中で、当社において申込件数が上位の商品を選定し、ご案内いたします。</li>
                    <li class="customer__definition-item">(2) お客さまが既に契約している保険契約で更改後もお客さまの意向に沿っている、かつ当社で取扱いができる商品の場合は、当該商品を選定し、ご案内いたします。</li>
                    <li class="customer__definition-item">(3) 各保険会社の新商品として発売されたものの中で、保障内容、保険料、利便性等において優位性が認められる場合は、当該商品を選定し、ご案内いたします。</li>
                </ul>
                <p class="customer__section-text">
                    実際の募集時には上記から選定した具体的な商品について、推奨する理由を明確にした上で、ご案内いたします。<br>
                    尚、当社は保険代理店であるため、金融商品の組成を行うことはございません。<br>
                    また、当社が保険会社から販売を委託されている保険商品を始めとする当社が取扱う金融商品について、パッケージでの販売を行う商品はございません。
                </p>
            </div>
            <div class="customer__section-box">
                <HeadingCorp :level="3">③顧客管理・アフターフォロー体制の整備</HeadingCorp>
                <p class="customer__section-text">
                    当社は、情報セキュリティ対策を十二分に行った上で、お客さまの情報を顧客管理システムにて一元管理を行っており、営業部門・管理部門といった部門やお電話・お手紙など書面・SMS・当社 WEB サイト上のお問い合わせフォーム等の経路を問わず、お客さまのお申し出・ご要望に会社として、速やかに対応するための体制を整備しております。<br>
                    また、当社は WEB サイトの運営と、いわゆるダイレクト型の自動車保険の販売を主体としているという事業特性を活かし、定期的に WEB サイト等によりお客さまへ情報の発信を行うとともに、保険の満期日等に合わせて定期的にお客さまへ SMS 等の配信を行い、お客さまの大切な契約の保全に努めるとともに、お客さまのライフスタイルに合わせて利用できるよう、年末年始等一部を除いて、土曜日・日曜日・祝祭日でもご利用いただける体制を整備しております。
                </p>
            </div>
        </section>

        <!-- 方針６ -->
        <section class="customer__section">
            <div class="customer__section-box">
                <HeadingCorp :level="2">方針６．保険募集管理体制の整備 【原則３，４，５，６】</HeadingCorp>
                <p class="customer__section-text">
                    当社は、前記方針 3～5 について、お客さまの属性やご意向に合った商品のご案内が行えているか、重要な事項等の説明が適正に行えているかどうか、保険募集業務のモニタリング・検証・改善に向けて、以下の取り組みを実施しております。<br>
                    モニタリング・検証・改善の状況は社長及び関係部門 へ報告を行い、経営としての具体的な改善施策を策定、実施し、当社として PDCA サイクルによる向上を図っております。
                </p>
            </div>
            <div class="customer__section-box">
                <HeadingCorp :level="3">①保険募集に係る社内規則等の整備</HeadingCorp>
                <p class="customer__section-text">
                    当社は募集代理店として、当社の規模・特性に応じた保険募集・コンプライアンス遵守に係る各種社内規則として、コンプライアンスマニュアルを始めとした各種業務ガイドライン・マニュアルを整備しております。<br>
                    これら各保険会社のガイドライン・マニュアル等  は募集人が保険募集時にいつでも確認できるような体制としております。<br>
                    また、お客さまの適正なご意向に沿った募集プロセスおよび情報提供を行うべき事項についても業務管理システムへ組み込み、適正な募集を行うための体制を整備しております。
                </p>
            </div>
            <div class="customer__section-box">
                <HeadingCorp :level="3">②募集人による自主点検によるセルフモニタリング・検証及び改善</HeadingCorp>
                <p class="customer__section-text">
                    上記社内規則等に準じた保険募集業務が行えているかについて、Eラーニングシステムを活用し、募集人自身の業務内容についてセルフチェックを行う体制を整備しております。
                </p>
            </div>
        </section>

        <!-- 方針７ -->
        <section class="customer__section">
            <HeadingCorp :level="2">方針７．従業員への適切な動機付けの枠組み 【原則７】</HeadingCorp>
            <div class="customer__section-box">
                <HeadingCorp :level="3">①継続的な教育体制の整備</HeadingCorp>
                <p class="customer__section-text">
                    当社では E ラーニングシステムを活用した動画コンテンツ等、教育・学習コンテンツを整備し、常に従業員が学習できる体制を構築しており、お客さまへも応対品質の向上に努めており、コンプライアンス教育のために実施しているコンプライアンステストをはじめ、必須受講項目は常に満点合格を課し募集人のコンプライアンス知識、取扱商品やサービスの理解を深める教育を実施して参ります。<br>
                    また、お客さま本位の業務運営を実現するため、従業員に対し、本宣言について、社内イントラネットにより周知し、認識度合いを月次の E ラーニングによるセルフモニタリングにより確認を行い、従業員に対する適切な動機づけの枠組みおよびガバナンス体制の構築を図っております。また従業員への浸透度合いについても定期的に検証・評価いたします。
                </p>
            </div>
            <div class="customer__section-box">
                <HeadingCorp :level="3">②評価・人事制度の整備</HeadingCorp>
                <p class="customer__section-text">
                    当社は従業員の成⾧が会社の成⾧であると考え、日々成⾧しつづける企業になるべく、様々な福利厚生や人事制度の整備、従業員が自由に意見できるシステムの構築、定期的な従業員アンケートの実施等を整え、一人ひとりの声を大切にすることで、従業員が 100%力を発揮できる環境作りに努めております。<br>
                    従業員が『この会社で良かった』 『この仕事ができて良かった』と思える気持ちが、お客さまへのより良いサービスの提供へ繋がると考えており、さらには、企業価値を高めることへ繋がると考え、今後も、従業員が本気で⾧く働きたいと思うことができる会社を目指しております。
                </p>
                <div class="customer__section-block">
                    <HeadingCorp :level="4">■評価制度</HeadingCorp>
                    当社は、これらのお客さま本位の業務運営を適正に行うにあたっては、従業員が⾧く、安心して働くことのできる環境を整備することは非常に重要なことであると考えております。<br>
                    従業員の評価については、当社としてお客さまに永続的に適切なご案内を行う上で、そのための職務や役職等に応じた固定給を中心としております。さらに昇給・昇格については保険募集業務品質に関する事項を査定に組み込むなど、従業員が⾧く働き続ける環境を整備し、従業員満足度・お客さま満足度の向上を目指してまいります。
                </div>
            </div>
        </section>

    </div>
  </main>
</template>

<style scoped lang="scss">
.customer {
    position: relative;
    width: min(91vw, 64.5rem);
    margin: auto;
    &::before {
        content: '';
        position: absolute;
        width: 20rem;
        height: 20rem;
        aspect-ratio: 1/1;
        left: -4rem;
        top: -3rem;
        border-radius: 20rem;
        box-sizing: border-box;
        border: 1.5rem solid #EFF7FF;
        z-index: -1;
        pointer-events: none;
    }
    &__body {
        padding: 2rem 0 4.5rem;
    }
    &__section {
        line-height: 150%;
        &:not(:last-child) {
            margin-bottom: 2.5rem;
        }
        a[href] {
            color: #2174C0;
            text-decoration: underline;
            overflow-wrap: anywhere;
            &:hover {
                opacity: 0.48;
                transition: opacity 0.3s ease;
            }
        }
    }
    &__section-box {
        &:not(:last-child) {
            margin-bottom: 1rem;
        }
    }
    &__section-text {
        &:has(+ div) {
            margin-bottom: 1rem;
        }
    }
    &__section-block {
        &:not(:last-child) {
            margin-bottom: 1rem;
        }
    }
    &__right-text {
        padding: 1rem 0;
        text-align: right;
    }
    &__number-item {
        margin-bottom: 0.5rem;
        text-indent: -1rem;
        padding-left: 1rem;
    }
    &__definition-item {
        margin-bottom: 0.5rem;
        text-indent: -1.2rem;
        padding-left: 1.2rem;
    }
    &__dot-item {
        text-indent: -1rem;
        padding-left: 1rem;
    }
    &__indent {
        padding-left: 1.2rem;
        li {
            text-indent: -0.2rem;
        }
    }
}

@include mixin.media(pc) {
    .customer {
        &::before {
            width: 32.5rem;
            height: 32.5rem;
            left: -10.7rem;
            top: -4rem;
            border-radius: 32.5rem;
            border: 2.5rem solid #EFF7FF;
        }
        &__body {
            padding: 4rem 0 5rem;
        }
        &__section {
            &:not(:last-child) {
                margin-bottom: 3rem;
            }
        }
    }
}
</style>
